import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  AssertionError3yq7q0knw9m5 as AssertionError,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { EOFException34hypof9gkxss as EOFException } from './NonJvmPlatform.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from './Util.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SegmentPool_instance26x4wee5nyx6a as SegmentPool_instance } from './SegmentPool.mjs';
import {
  ByteString2qc03wzjsovk as ByteString,
  Companion_getInstance28gds36m4006o as Companion_getInstance,
} from './ByteString.mjs';
import { commonToUtf8Stringyih6e1qg1yoo as commonToUtf8String } from './internal/-Utf8.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  readUtf8Line36yidw3sdfobh as readUtf8Line,
  selectPrefix5tb3rl5iltlw as selectPrefix,
  rangeEquals13q7f5dia0en as rangeEquals,
} from './internal/Buffer.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SegmentedByteString5e5x58c4yl7l as SegmentedByteString } from './SegmentedByteString.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var UnsafeCursorClass;
function UnsafeCursor() {
  if (UnsafeCursorClass === VOID) {
    class $ {
      constructor() {
        this.r3x_1 = null;
        this.s3x_1 = false;
        this.t3x_1 = null;
        this.u3x_1 = -1n;
        this.v3x_1 = null;
        this.w3x_1 = -1;
        this.x3x_1 = -1;
      }
      q6() {
        // Inline function 'okio.internal.commonClose' call
        // Inline function 'kotlin.check' call
        if (!!(this.r3x_1 == null)) {
          var message = 'not attached to a buffer';
          throw IllegalStateException().o(toString(message));
        }
        this.r3x_1 = null;
        this.t3x_1 = null;
        this.u3x_1 = -1n;
        this.v3x_1 = null;
        this.w3x_1 = -1;
        this.x3x_1 = -1;
      }
    }
    initMetadataForClass($, 'UnsafeCursor', UnsafeCursor);
    UnsafeCursorClass = $;
  }
  return UnsafeCursorClass;
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.h3v_1 = null;
        this.i3v_1 = 0n;
      }
      y3x() {
        return this;
      }
      z3x() {
        return this.i3v_1 === 0n;
      }
      a3y(byteCount) {
        if (this.i3v_1 < byteCount)
          throw EOFException().e3y(null);
      }
      f3y(byteCount) {
        return this.i3v_1 >= byteCount;
      }
      g3y(out, offset, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonCopyTo' call
          var offset_0 = offset;
          var byteCount_0 = byteCount;
          checkOffsetAndCount(this.i3v_1, offset_0, byteCount_0);
          if (byteCount_0 === 0n) {
            tmp$ret$0 = this;
            break $l$block;
          }
          out.i3v_1 = add(out.i3v_1, byteCount_0);
          var s = this.h3v_1;
          while (offset_0 >= fromInt(ensureNotNull(s).z3v_1 - s.y3v_1 | 0)) {
            offset_0 = subtract(offset_0, fromInt(s.z3v_1 - s.y3v_1 | 0));
            s = s.c3w_1;
          }
          while (byteCount_0 > 0n) {
            var copy = ensureNotNull(s).g3w();
            copy.y3v_1 = copy.y3v_1 + convertToInt(offset_0) | 0;
            var tmp = copy;
            var tmp0 = copy.y3v_1 + convertToInt(byteCount_0) | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = copy.z3v_1;
            tmp.z3v_1 = Math.min(tmp0, b);
            if (out.h3v_1 == null) {
              copy.d3w_1 = copy;
              copy.c3w_1 = copy.d3w_1;
              out.h3v_1 = copy.c3w_1;
            } else {
              ensureNotNull(ensureNotNull(out.h3v_1).d3w_1).i3w(copy);
            }
            byteCount_0 = subtract(byteCount_0, fromInt(copy.z3v_1 - copy.y3v_1 | 0));
            offset_0 = 0n;
            s = s.c3w_1;
          }
          tmp$ret$0 = this;
        }
        return tmp$ret$0;
      }
      v3w(pos) {
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'okio.internal.commonGet' call
          checkOffsetAndCount(this.i3v_1, pos, 1n);
          // Inline function 'okio.internal.seek' call
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = ensureNotNull(null).x3v_1[convertToInt(subtract(add(numberToLong(null.y3v_1), pos), -1n))];
            break $l$block_1;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          if (subtract(this.i3v_1, pos) < pos) {
            var offset = this.i3v_1;
            while (offset > pos) {
              s = ensureNotNull(s.d3w_1);
              offset = subtract(offset, fromInt(s.z3v_1 - s.y3v_1 | 0));
            }
            var tmp0 = s;
            var offset_0 = offset;
            tmp$ret$0 = ensureNotNull(tmp0).x3v_1[convertToInt(subtract(add(numberToLong(tmp0.y3v_1), pos), offset_0))];
            break $l$block_1;
          } else {
            var offset_1 = 0n;
            $l$loop: while (true) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s.z3v_1 - s.y3v_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > pos)
                break $l$loop;
              s = ensureNotNull(s.c3w_1);
              offset_1 = nextOffset;
            }
            var tmp0_1 = s;
            var offset_2 = offset_1;
            tmp$ret$0 = ensureNotNull(tmp0_1).x3v_1[convertToInt(subtract(add(numberToLong(tmp0_1.y3v_1), pos), offset_2))];
            break $l$block_1;
          }
        }
        return tmp$ret$0;
      }
      h3y() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonCompleteSegmentByteCount' call
          var result = this.i3v_1;
          if (result === 0n) {
            tmp$ret$0 = 0n;
            break $l$block;
          }
          var tail = ensureNotNull(ensureNotNull(this.h3v_1).d3w_1);
          if (tail.z3v_1 < 8192 && tail.b3w_1) {
            result = subtract(result, fromInt(tail.z3v_1 - tail.y3v_1 | 0));
          }
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      i3y() {
        // Inline function 'okio.internal.commonReadByte' call
        if (this.i3v_1 === 0n)
          throw EOFException().j3y();
        var segment = ensureNotNull(this.h3v_1);
        var pos = segment.y3v_1;
        var limit = segment.z3v_1;
        var data = segment.x3v_1;
        var tmp0 = pos;
        pos = tmp0 + 1 | 0;
        var b = data[tmp0];
        this.i3v_1 = subtract(this.i3v_1, 1n);
        if (pos === limit) {
          this.h3v_1 = segment.h3w();
          SegmentPool_instance.p3w(segment);
        } else {
          segment.y3v_1 = pos;
        }
        return b;
      }
      u3v() {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'okio.internal.commonReadInt' call
          if (this.i3v_1 < 4n)
            throw EOFException().j3y();
          var segment = ensureNotNull(this.h3v_1);
          var pos = segment.y3v_1;
          var limit = segment.z3v_1;
          if (fromInt(limit - pos | 0) < 4n) {
            // Inline function 'okio.and' call
            var tmp = (this.i3y() & 255) << 24;
            // Inline function 'okio.and' call
            var tmp_0 = tmp | (this.i3y() & 255) << 16;
            // Inline function 'okio.and' call
            var tmp_1 = tmp_0 | (this.i3y() & 255) << 8;
            // Inline function 'okio.and' call
            tmp$ret$4 = tmp_1 | this.i3y() & 255;
            break $l$block;
          }
          var data = segment.x3v_1;
          var tmp3 = pos;
          pos = tmp3 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_2 = (data[tmp3] & 255) << 24;
          var tmp2 = pos;
          pos = tmp2 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_3 = tmp_2 | (data[tmp2] & 255) << 16;
          var tmp1 = pos;
          pos = tmp1 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_4 = tmp_3 | (data[tmp1] & 255) << 8;
          var tmp0 = pos;
          pos = tmp0 + 1 | 0;
          // Inline function 'okio.and' call
          var i = tmp_4 | data[tmp0] & 255;
          this.i3v_1 = subtract(this.i3v_1, 4n);
          if (pos === limit) {
            this.h3v_1 = segment.h3w();
            SegmentPool_instance.p3w(segment);
          } else {
            segment.y3v_1 = pos;
          }
          tmp$ret$4 = i;
        }
        return tmp$ret$4;
      }
      k3y() {
        // Inline function 'okio.internal.commonReadByteString' call
        return this.l3y(this.i3v_1);
      }
      l3y(byteCount) {
        var tmp$ret$4;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadByteString' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
            var message = 'byteCount: ' + byteCount.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          if (this.i3v_1 < byteCount)
            throw EOFException().j3y();
          if (byteCount >= 4096n) {
            // Inline function 'kotlin.also' call
            var this_0 = this.n3y(convertToInt(byteCount));
            this.j3v(byteCount);
            tmp$ret$4 = this_0;
            break $l$block_0;
          } else {
            tmp$ret$4 = new (ByteString())(this.m3y(byteCount));
            break $l$block_0;
          }
        }
        return tmp$ret$4;
      }
      o3y() {
        return this.w3w(this.i3v_1);
      }
      w3w(byteCount) {
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
            var message = 'byteCount: ' + byteCount.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          if (this.i3v_1 < byteCount)
            throw EOFException().j3y();
          if (byteCount === 0n) {
            tmp$ret$2 = '';
            break $l$block_0;
          }
          var s = ensureNotNull(this.h3v_1);
          if (add(numberToLong(s.y3v_1), byteCount) > fromInt(s.z3v_1)) {
            tmp$ret$2 = commonToUtf8String(this.m3y(byteCount));
            break $l$block_0;
          }
          var result = commonToUtf8String(s.x3v_1, s.y3v_1, s.y3v_1 + convertToInt(byteCount) | 0);
          s.y3v_1 = s.y3v_1 + convertToInt(byteCount) | 0;
          this.i3v_1 = subtract(this.i3v_1, byteCount);
          if (s.y3v_1 === s.z3v_1) {
            this.h3v_1 = s.h3w();
            SegmentPool_instance.p3w(s);
          }
          tmp$ret$2 = result;
        }
        return tmp$ret$2;
      }
      p3y() {
        return this.q3y(9223372036854775807n);
      }
      q3y(limit) {
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8LineStrict' call
          // Inline function 'kotlin.require' call
          if (!(limit >= 0n)) {
            var message = 'limit < 0: ' + limit.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          var scanLength = limit === 9223372036854775807n ? 9223372036854775807n : add(limit, 1n);
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(10);
          var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
          var newline = this.r3y(toByte(tmp$ret$2), 0n, scanLength);
          if (!(newline === -1n)) {
            tmp$ret$3 = readUtf8Line(this, newline);
            break $l$block_0;
          }
          var tmp;
          var tmp_0;
          if (scanLength < this.i3v_1) {
            // Inline function 'kotlin.Long.minus' call
            var tmp$ret$4 = subtract(scanLength, fromInt(1));
            var tmp_1 = this.v3w(tmp$ret$4);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(13);
            var tmp$ret$5 = Char__toInt_impl_vasixd(this_1);
            tmp_0 = tmp_1 === toByte(tmp$ret$5);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp_2 = this.v3w(scanLength);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(10);
            var tmp$ret$6 = Char__toInt_impl_vasixd(this_2);
            tmp = tmp_2 === toByte(tmp$ret$6);
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$3 = readUtf8Line(this, scanLength);
            break $l$block_0;
          }
          var data = new (Buffer())();
          // Inline function 'okio.minOf' call
          var b = this.i3v_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(32);
          var tmp$ret$8 = a <= b ? a : b;
          this.g3y(data, 0n, tmp$ret$8);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = this.i3v_1;
          var tmp$ret$9 = a_0 <= limit ? a_0 : limit;
          throw EOFException().e3y('\\n not found: limit=' + tmp$ret$9.toString() + ' content=' + data.k3y().j3x() + '\u2026');
        }
        return tmp$ret$3;
      }
      s3y(options) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonSelect' call
          var index = selectPrefix(this, options);
          if (index === -1) {
            tmp$ret$0 = -1;
            break $l$block;
          }
          var selectedSize = options.q3v_1[index].v2();
          this.j3v(fromInt(selectedSize));
          tmp$ret$0 = index;
        }
        return tmp$ret$0;
      }
      t3y() {
        // Inline function 'okio.internal.commonReadByteArray' call
        return this.m3y(this.i3v_1);
      }
      m3y(byteCount) {
        // Inline function 'okio.internal.commonReadByteArray' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message));
        }
        if (this.i3v_1 < byteCount)
          throw EOFException().j3y();
        var result = new Int8Array(convertToInt(byteCount));
        this.u3y(result);
        return result;
      }
      u3y(sink) {
        // Inline function 'okio.internal.commonReadFully' call
        var offset = 0;
        while (offset < sink.length) {
          var read = this.v3y(sink, offset, sink.length - offset | 0);
          if (read === -1)
            throw EOFException().j3y();
          offset = offset + read | 0;
        }
        return Unit_instance;
      }
      v3y(sink, offset, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          checkOffsetAndCount(fromInt(sink.length), fromInt(offset), fromInt(byteCount));
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = -1;
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = s.z3v_1 - s.y3v_1 | 0;
          var toCopy = Math.min(byteCount, b);
          var tmp0 = s.x3v_1;
          var tmp6 = s.y3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = s.y3v_1 + toCopy | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_0, sink, offset, tmp6, endIndex);
          s.y3v_1 = s.y3v_1 + toCopy | 0;
          this.i3v_1 = subtract(this.i3v_1, fromInt(toCopy));
          if (s.y3v_1 === s.z3v_1) {
            this.h3v_1 = s.h3w();
            SegmentPool_instance.p3w(s);
          }
          tmp$ret$0 = toCopy;
        }
        return tmp$ret$0;
      }
      f5() {
        // Inline function 'okio.internal.commonClear' call
        this.j3v(this.i3v_1);
        return Unit_instance;
      }
      j3v(byteCount) {
        // Inline function 'okio.internal.commonSkip' call
        var byteCount_0 = byteCount;
        while (byteCount_0 > 0n) {
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().j3y();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = byteCount_0;
          // Inline function 'okio.minOf' call
          var b = head.z3v_1 - head.y3v_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$1 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$1);
          this.i3v_1 = subtract(this.i3v_1, fromInt(toSkip));
          byteCount_0 = subtract(byteCount_0, fromInt(toSkip));
          head.y3v_1 = head.y3v_1 + toSkip | 0;
          if (head.y3v_1 === head.z3v_1) {
            this.h3v_1 = head.h3w();
            SegmentPool_instance.p3w(head);
          }
        }
        return Unit_instance;
      }
      w3y(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        var byteCount = byteString.v2();
        byteString.n3x(this, 0, byteCount);
        return this;
      }
      x3y(minimumCapacity) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'okio.internal.commonWritableSegment' call
          // Inline function 'kotlin.require' call
          if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
            var message = 'unexpected capacity';
            throw IllegalArgumentException().s2(toString(message));
          }
          if (this.h3v_1 == null) {
            var result = SegmentPool_instance.m3w();
            this.h3v_1 = result;
            result.d3w_1 = result;
            result.c3w_1 = result;
            tmp$ret$2 = result;
            break $l$block;
          }
          var tail = ensureNotNull(this.h3v_1).d3w_1;
          if ((ensureNotNull(tail).z3v_1 + minimumCapacity | 0) > 8192 || !tail.b3w_1) {
            tail = tail.i3w(SegmentPool_instance.m3w());
          }
          tmp$ret$2 = tail;
        }
        return tmp$ret$2;
      }
      y3y(string) {
        return this.z3y(string, 0, string.length);
      }
      z3y(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.require' call
        if (!(beginIndex >= 0)) {
          var message = 'beginIndex < 0: ' + beginIndex;
          throw IllegalArgumentException().s2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex >= beginIndex)) {
          var message_0 = 'endIndex < beginIndex: ' + endIndex + ' < ' + beginIndex;
          throw IllegalArgumentException().s2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex <= string.length)) {
          var message_1 = 'endIndex > string.length: ' + endIndex + ' > ' + string.length;
          throw IllegalArgumentException().s2(toString(message_1));
        }
        var i = beginIndex;
        while (i < endIndex) {
          // Inline function 'kotlin.code' call
          var this_0 = charCodeAt(string, i);
          var c = Char__toInt_impl_vasixd(this_0);
          if (c < 128) {
            var tail = this.x3y(1);
            var data = tail.x3v_1;
            var segmentOffset = tail.z3v_1 - i | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = 8192 - segmentOffset | 0;
            var runLimit = Math.min(endIndex, b);
            var tmp0 = i;
            i = tmp0 + 1 | 0;
            data[segmentOffset + tmp0 | 0] = toByte(c);
            $l$loop: while (i < runLimit) {
              // Inline function 'kotlin.code' call
              var this_1 = charCodeAt(string, i);
              c = Char__toInt_impl_vasixd(this_1);
              if (c >= 128)
                break $l$loop;
              var tmp1 = i;
              i = tmp1 + 1 | 0;
              data[segmentOffset + tmp1 | 0] = toByte(c);
            }
            var runSize = (i + segmentOffset | 0) - tail.z3v_1 | 0;
            tail.z3v_1 = tail.z3v_1 + runSize | 0;
            this.i3v_1 = add(this.i3v_1, fromInt(runSize));
          } else if (c < 2048) {
            var tail_0 = this.x3y(2);
            tail_0.x3v_1[tail_0.z3v_1] = toByte(c >> 6 | 192);
            tail_0.x3v_1[tail_0.z3v_1 + 1 | 0] = toByte(c & 63 | 128);
            tail_0.z3v_1 = tail_0.z3v_1 + 2 | 0;
            this.i3v_1 = add(this.i3v_1, 2n);
            i = i + 1 | 0;
          } else if (c < 55296 || c > 57343) {
            var tail_1 = this.x3y(3);
            tail_1.x3v_1[tail_1.z3v_1] = toByte(c >> 12 | 224);
            tail_1.x3v_1[tail_1.z3v_1 + 1 | 0] = toByte(c >> 6 & 63 | 128);
            tail_1.x3v_1[tail_1.z3v_1 + 2 | 0] = toByte(c & 63 | 128);
            tail_1.z3v_1 = tail_1.z3v_1 + 3 | 0;
            this.i3v_1 = add(this.i3v_1, 3n);
            i = i + 1 | 0;
          } else {
            var tmp;
            if ((i + 1 | 0) < endIndex) {
              // Inline function 'kotlin.code' call
              var this_2 = charCodeAt(string, i + 1 | 0);
              tmp = Char__toInt_impl_vasixd(this_2);
            } else {
              tmp = 0;
            }
            var low = tmp;
            if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
              // Inline function 'kotlin.code' call
              var this_3 = _Char___init__impl__6a9atx(63);
              var tmp$ret$10 = Char__toInt_impl_vasixd(this_3);
              this.a3z(tmp$ret$10);
              i = i + 1 | 0;
            } else {
              var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
              var tail_2 = this.x3y(4);
              tail_2.x3v_1[tail_2.z3v_1] = toByte(codePoint >> 18 | 240);
              tail_2.x3v_1[tail_2.z3v_1 + 1 | 0] = toByte(codePoint >> 12 & 63 | 128);
              tail_2.x3v_1[tail_2.z3v_1 + 2 | 0] = toByte(codePoint >> 6 & 63 | 128);
              tail_2.x3v_1[tail_2.z3v_1 + 3 | 0] = toByte(codePoint & 63 | 128);
              tail_2.z3v_1 = tail_2.z3v_1 + 4 | 0;
              this.i3v_1 = add(this.i3v_1, 4n);
              i = i + 2 | 0;
            }
          }
        }
        return this;
      }
      b3z(source) {
        // Inline function 'okio.internal.commonWrite' call
        return this.x3w(source, 0, source.length);
      }
      x3w(source, offset, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        var offset_0 = offset;
        checkOffsetAndCount(fromInt(source.length), fromInt(offset_0), fromInt(byteCount));
        var limit = offset_0 + byteCount | 0;
        while (offset_0 < limit) {
          var tail = this.x3y(1);
          var tmp0 = limit - offset_0 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = 8192 - tail.z3v_1 | 0;
          var toCopy = Math.min(tmp0, b);
          var tmp2 = tail.x3v_1;
          var tmp4 = tail.z3v_1;
          var tmp6 = offset_0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = offset_0 + toCopy | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = source;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, tmp4, tmp6, endIndex);
          offset_0 = offset_0 + toCopy | 0;
          tail.z3v_1 = tail.z3v_1 + toCopy | 0;
        }
        this.i3v_1 = add(this.i3v_1, fromInt(byteCount));
        return this;
      }
      o3v(source) {
        // Inline function 'okio.internal.commonWriteAll' call
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.c3z(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      a3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        var tail = this.x3y(1);
        var tmp1 = tail.z3v_1;
        tail.z3v_1 = tmp1 + 1 | 0;
        tail.x3v_1[tmp1] = toByte(b);
        this.i3v_1 = add(this.i3v_1, 1n);
        return this;
      }
      n3v(i) {
        // Inline function 'okio.internal.commonWriteInt' call
        var tail = this.x3y(4);
        var data = tail.x3v_1;
        var limit = tail.z3v_1;
        var tmp0 = limit;
        limit = tmp0 + 1 | 0;
        data[tmp0] = toByte((i >>> 24 | 0) & 255);
        var tmp1 = limit;
        limit = tmp1 + 1 | 0;
        data[tmp1] = toByte((i >>> 16 | 0) & 255);
        var tmp2 = limit;
        limit = tmp2 + 1 | 0;
        data[tmp2] = toByte((i >>> 8 | 0) & 255);
        var tmp3 = limit;
        limit = tmp3 + 1 | 0;
        data[tmp3] = toByte(i & 255);
        tail.z3v_1 = limit;
        this.i3v_1 = add(this.i3v_1, 4n);
        return this;
      }
      g3v(source, byteCount) {
        var tmp$ret$4;
        $l$block: {
          // Inline function 'okio.internal.commonWrite' call
          var byteCount_0 = byteCount;
          // Inline function 'kotlin.require' call
          if (!!(source === this)) {
            var message = 'source == this';
            throw IllegalArgumentException().s2(toString(message));
          }
          checkOffsetAndCount(source.i3v_1, 0n, byteCount_0);
          while (byteCount_0 > 0n) {
            if (byteCount_0 < fromInt(ensureNotNull(source.h3v_1).z3v_1 - ensureNotNull(source.h3v_1).y3v_1 | 0)) {
              var tail = !(this.h3v_1 == null) ? ensureNotNull(this.h3v_1).d3w_1 : null;
              var tmp;
              if (!(tail == null) && tail.b3w_1) {
                var tmp0 = byteCount_0;
                // Inline function 'kotlin.Long.plus' call
                var other = tail.z3v_1;
                var tmp0_0 = add(tmp0, fromInt(other));
                // Inline function 'kotlin.Long.minus' call
                var other_0 = tail.a3w_1 ? 0 : tail.y3v_1;
                tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
              } else {
                tmp = false;
              }
              if (tmp) {
                ensureNotNull(source.h3v_1).o3w(tail, convertToInt(byteCount_0));
                source.i3v_1 = subtract(source.i3v_1, byteCount_0);
                this.i3v_1 = add(this.i3v_1, byteCount_0);
                tmp$ret$4 = Unit_instance;
                break $l$block;
              } else {
                source.h3v_1 = ensureNotNull(source.h3v_1).j3w(convertToInt(byteCount_0));
              }
            }
            var segmentToMove = source.h3v_1;
            var movedByteCount = fromInt(ensureNotNull(segmentToMove).z3v_1 - segmentToMove.y3v_1 | 0);
            source.h3v_1 = segmentToMove.h3w();
            if (this.h3v_1 == null) {
              this.h3v_1 = segmentToMove;
              segmentToMove.d3w_1 = segmentToMove;
              segmentToMove.c3w_1 = segmentToMove.d3w_1;
            } else {
              var tail_0 = ensureNotNull(this.h3v_1).d3w_1;
              tail_0 = ensureNotNull(tail_0).i3w(segmentToMove);
              tail_0.n3w();
            }
            source.i3v_1 = subtract(source.i3v_1, movedByteCount);
            this.i3v_1 = add(this.i3v_1, movedByteCount);
            byteCount_0 = subtract(byteCount_0, movedByteCount);
          }
          tmp$ret$4 = Unit_instance;
        }
        return tmp$ret$4;
      }
      c3z(sink, byteCount) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          var byteCount_0 = byteCount;
          // Inline function 'kotlin.require' call
          if (!(byteCount_0 >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount_0.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          if (this.i3v_1 === 0n) {
            tmp$ret$2 = -1n;
            break $l$block;
          }
          if (byteCount_0 > this.i3v_1)
            byteCount_0 = this.i3v_1;
          sink.g3v(this, byteCount_0);
          tmp$ret$2 = byteCount_0;
        }
        return tmp$ret$2;
      }
      r3y(b, fromIndex, toIndex) {
        var tmp$ret$2;
        $l$block_8: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          var toIndex_0 = toIndex;
          // Inline function 'kotlin.require' call
          if (!(0n <= fromIndex_0 ? fromIndex_0 <= toIndex_0 : false)) {
            var message = 'size=' + this.i3v_1.toString() + ' fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex_0.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          if (toIndex_0 > this.i3v_1)
            toIndex_0 = this.i3v_1;
          if (fromIndex_0 === toIndex_0) {
            tmp$ret$2 = -1n;
            break $l$block_8;
          }
          // Inline function 'okio.internal.seek' call
          var fromIndex_1 = fromIndex_0;
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (null == null) {
              tmp$ret$2 = -1n;
              break $l$block_8;
            } else {
              tmp_0 = null;
            }
            var s = tmp_0;
            var offset = -1n;
            while (offset < toIndex_0) {
              var data = s.x3v_1;
              var tmp0 = fromInt(s.z3v_1);
              // Inline function 'kotlin.comparisons.minOf' call
              var b_0 = subtract(add(numberToLong(s.y3v_1), toIndex_0), offset);
              var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
              var limit = convertToInt(tmp$ret$3);
              var pos = convertToInt(subtract(add(numberToLong(s.y3v_1), fromIndex_0), offset));
              while (pos < limit) {
                if (data[pos] === b) {
                  tmp$ret$2 = add(numberToLong(pos - s.y3v_1 | 0), offset);
                  break $l$block_8;
                }
                pos = pos + 1 | 0;
              }
              offset = add(offset, fromInt(s.z3v_1 - s.y3v_1 | 0));
              fromIndex_0 = offset;
              s = ensureNotNull(s.c3w_1);
            }
            tmp$ret$2 = -1n;
            break $l$block_8;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s_0 = tmp;
          if (subtract(this.i3v_1, fromIndex_1) < fromIndex_1) {
            var offset_0 = this.i3v_1;
            while (offset_0 > fromIndex_1) {
              s_0 = ensureNotNull(s_0.d3w_1);
              offset_0 = subtract(offset_0, fromInt(s_0.z3v_1 - s_0.y3v_1 | 0));
            }
            var tmp0_0 = s_0;
            var offset_1 = offset_0;
            var tmp_1;
            if (tmp0_0 == null) {
              tmp$ret$2 = -1n;
              break $l$block_8;
            } else {
              tmp_1 = tmp0_0;
            }
            var s_1 = tmp_1;
            var offset_2 = offset_1;
            while (offset_2 < toIndex_0) {
              var data_0 = s_1.x3v_1;
              var tmp0_1 = fromInt(s_1.z3v_1);
              // Inline function 'kotlin.comparisons.minOf' call
              var b_1 = subtract(add(numberToLong(s_1.y3v_1), toIndex_0), offset_2);
              var tmp$ret$5 = tmp0_1 <= b_1 ? tmp0_1 : b_1;
              var limit_0 = convertToInt(tmp$ret$5);
              var pos_0 = convertToInt(subtract(add(numberToLong(s_1.y3v_1), fromIndex_0), offset_2));
              while (pos_0 < limit_0) {
                if (data_0[pos_0] === b) {
                  tmp$ret$2 = add(numberToLong(pos_0 - s_1.y3v_1 | 0), offset_2);
                  break $l$block_8;
                }
                pos_0 = pos_0 + 1 | 0;
              }
              offset_2 = add(offset_2, fromInt(s_1.z3v_1 - s_1.y3v_1 | 0));
              fromIndex_0 = offset_2;
              s_1 = ensureNotNull(s_1.c3w_1);
            }
            tmp$ret$2 = -1n;
            break $l$block_8;
          } else {
            var offset_3 = 0n;
            $l$loop: while (true) {
              var tmp0_2 = offset_3;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.z3v_1 - s_0.y3v_1 | 0;
              var nextOffset = add(tmp0_2, fromInt(other));
              if (nextOffset > fromIndex_1)
                break $l$loop;
              s_0 = ensureNotNull(s_0.c3w_1);
              offset_3 = nextOffset;
            }
            var tmp0_3 = s_0;
            var offset_4 = offset_3;
            var tmp_2;
            if (tmp0_3 == null) {
              tmp$ret$2 = -1n;
              break $l$block_8;
            } else {
              tmp_2 = tmp0_3;
            }
            var s_2 = tmp_2;
            var offset_5 = offset_4;
            while (offset_5 < toIndex_0) {
              var data_1 = s_2.x3v_1;
              var tmp0_4 = fromInt(s_2.z3v_1);
              // Inline function 'kotlin.comparisons.minOf' call
              var b_2 = subtract(add(numberToLong(s_2.y3v_1), toIndex_0), offset_5);
              var tmp$ret$7 = tmp0_4 <= b_2 ? tmp0_4 : b_2;
              var limit_1 = convertToInt(tmp$ret$7);
              var pos_1 = convertToInt(subtract(add(numberToLong(s_2.y3v_1), fromIndex_0), offset_5));
              while (pos_1 < limit_1) {
                if (data_1[pos_1] === b) {
                  tmp$ret$2 = add(numberToLong(pos_1 - s_2.y3v_1 | 0), offset_5);
                  break $l$block_8;
                }
                pos_1 = pos_1 + 1 | 0;
              }
              offset_5 = add(offset_5, fromInt(s_2.z3v_1 - s_2.y3v_1 | 0));
              fromIndex_0 = offset_5;
              s_2 = ensureNotNull(s_2.c3w_1);
            }
            tmp$ret$2 = -1n;
            break $l$block_8;
          }
        }
        return tmp$ret$2;
      }
      d3z(bytes) {
        return this.e3z(bytes, 0n);
      }
      e3z(bytes, fromIndex) {
        var tmp$ret$4;
        $l$block_7: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.require' call
          if (!(bytes.v2() > 0)) {
            var message = 'bytes is empty';
            throw IllegalArgumentException().s2(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!(fromIndex_0 >= 0n)) {
            var message_0 = 'fromIndex < 0: ' + fromIndex_0.toString();
            throw IllegalArgumentException().s2(toString(message_0));
          }
          // Inline function 'okio.internal.seek' call
          var fromIndex_1 = fromIndex_0;
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (null == null) {
              tmp$ret$4 = -1n;
              break $l$block_7;
            } else {
              tmp_0 = null;
            }
            var s = tmp_0;
            var offset = -1n;
            var targetByteArray = bytes.i3x();
            var b0 = targetByteArray[0];
            var bytesSize = bytes.v2();
            // Inline function 'kotlin.Long.minus' call
            var this_0 = this.i3v_1;
            var tmp$ret$5 = subtract(this_0, fromInt(bytesSize));
            var resultLimit = add(tmp$ret$5, 1n);
            while (offset < resultLimit) {
              var data = s.x3v_1;
              var tmp0 = s.z3v_1;
              // Inline function 'okio.minOf' call
              var b = subtract(add(numberToLong(s.y3v_1), resultLimit), offset);
              // Inline function 'kotlin.comparisons.minOf' call
              var a = fromInt(tmp0);
              var tmp$ret$7 = a <= b ? a : b;
              var segmentLimit = convertToInt(tmp$ret$7);
              var inductionVariable = convertToInt(subtract(add(numberToLong(s.y3v_1), fromIndex_0), offset));
              if (inductionVariable < segmentLimit)
                do {
                  var pos = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  if (data[pos] === b0 && rangeEquals(s, pos + 1 | 0, targetByteArray, 1, bytesSize)) {
                    tmp$ret$4 = add(numberToLong(pos - s.y3v_1 | 0), offset);
                    break $l$block_7;
                  }
                }
                 while (inductionVariable < segmentLimit);
              offset = add(offset, fromInt(s.z3v_1 - s.y3v_1 | 0));
              fromIndex_0 = offset;
              s = ensureNotNull(s.c3w_1);
            }
            tmp$ret$4 = -1n;
            break $l$block_7;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s_0 = tmp;
          if (subtract(this.i3v_1, fromIndex_1) < fromIndex_1) {
            var offset_0 = this.i3v_1;
            while (offset_0 > fromIndex_1) {
              s_0 = ensureNotNull(s_0.d3w_1);
              offset_0 = subtract(offset_0, fromInt(s_0.z3v_1 - s_0.y3v_1 | 0));
            }
            var tmp0_0 = s_0;
            var offset_1 = offset_0;
            var tmp_1;
            if (tmp0_0 == null) {
              tmp$ret$4 = -1n;
              break $l$block_7;
            } else {
              tmp_1 = tmp0_0;
            }
            var s_1 = tmp_1;
            var offset_2 = offset_1;
            var targetByteArray_0 = bytes.i3x();
            var b0_0 = targetByteArray_0[0];
            var bytesSize_0 = bytes.v2();
            // Inline function 'kotlin.Long.minus' call
            var this_1 = this.i3v_1;
            var tmp$ret$9 = subtract(this_1, fromInt(bytesSize_0));
            var resultLimit_0 = add(tmp$ret$9, 1n);
            while (offset_2 < resultLimit_0) {
              var data_0 = s_1.x3v_1;
              var tmp0_1 = s_1.z3v_1;
              // Inline function 'okio.minOf' call
              var b_0 = subtract(add(numberToLong(s_1.y3v_1), resultLimit_0), offset_2);
              // Inline function 'kotlin.comparisons.minOf' call
              var a_0 = fromInt(tmp0_1);
              var tmp$ret$11 = a_0 <= b_0 ? a_0 : b_0;
              var segmentLimit_0 = convertToInt(tmp$ret$11);
              var inductionVariable_0 = convertToInt(subtract(add(numberToLong(s_1.y3v_1), fromIndex_0), offset_2));
              if (inductionVariable_0 < segmentLimit_0)
                do {
                  var pos_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  if (data_0[pos_0] === b0_0 && rangeEquals(s_1, pos_0 + 1 | 0, targetByteArray_0, 1, bytesSize_0)) {
                    tmp$ret$4 = add(numberToLong(pos_0 - s_1.y3v_1 | 0), offset_2);
                    break $l$block_7;
                  }
                }
                 while (inductionVariable_0 < segmentLimit_0);
              offset_2 = add(offset_2, fromInt(s_1.z3v_1 - s_1.y3v_1 | 0));
              fromIndex_0 = offset_2;
              s_1 = ensureNotNull(s_1.c3w_1);
            }
            tmp$ret$4 = -1n;
            break $l$block_7;
          } else {
            var offset_3 = 0n;
            $l$loop: while (true) {
              var tmp0_2 = offset_3;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.z3v_1 - s_0.y3v_1 | 0;
              var nextOffset = add(tmp0_2, fromInt(other));
              if (nextOffset > fromIndex_1)
                break $l$loop;
              s_0 = ensureNotNull(s_0.c3w_1);
              offset_3 = nextOffset;
            }
            var tmp0_3 = s_0;
            var offset_4 = offset_3;
            var tmp_2;
            if (tmp0_3 == null) {
              tmp$ret$4 = -1n;
              break $l$block_7;
            } else {
              tmp_2 = tmp0_3;
            }
            var s_2 = tmp_2;
            var offset_5 = offset_4;
            var targetByteArray_1 = bytes.i3x();
            var b0_1 = targetByteArray_1[0];
            var bytesSize_1 = bytes.v2();
            // Inline function 'kotlin.Long.minus' call
            var this_2 = this.i3v_1;
            var tmp$ret$13 = subtract(this_2, fromInt(bytesSize_1));
            var resultLimit_1 = add(tmp$ret$13, 1n);
            while (offset_5 < resultLimit_1) {
              var data_1 = s_2.x3v_1;
              var tmp0_4 = s_2.z3v_1;
              // Inline function 'okio.minOf' call
              var b_1 = subtract(add(numberToLong(s_2.y3v_1), resultLimit_1), offset_5);
              // Inline function 'kotlin.comparisons.minOf' call
              var a_1 = fromInt(tmp0_4);
              var tmp$ret$15 = a_1 <= b_1 ? a_1 : b_1;
              var segmentLimit_1 = convertToInt(tmp$ret$15);
              var inductionVariable_1 = convertToInt(subtract(add(numberToLong(s_2.y3v_1), fromIndex_0), offset_5));
              if (inductionVariable_1 < segmentLimit_1)
                do {
                  var pos_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  if (data_1[pos_1] === b0_1 && rangeEquals(s_2, pos_1 + 1 | 0, targetByteArray_1, 1, bytesSize_1)) {
                    tmp$ret$4 = add(numberToLong(pos_1 - s_2.y3v_1 | 0), offset_5);
                    break $l$block_7;
                  }
                }
                 while (inductionVariable_1 < segmentLimit_1);
              offset_5 = add(offset_5, fromInt(s_2.z3v_1 - s_2.y3v_1 | 0));
              fromIndex_0 = offset_5;
              s_2 = ensureNotNull(s_2.c3w_1);
            }
            tmp$ret$4 = -1n;
            break $l$block_7;
          }
        }
        return tmp$ret$4;
      }
      f3z(targetBytes) {
        return this.g3z(targetBytes, 0n);
      }
      g3z(targetBytes, fromIndex) {
        var tmp$ret$2;
        $l$block_10: {
          // Inline function 'okio.internal.commonIndexOfElement' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.require' call
          if (!(fromIndex_0 >= 0n)) {
            var message = 'fromIndex < 0: ' + fromIndex_0.toString();
            throw IllegalArgumentException().s2(toString(message));
          }
          // Inline function 'okio.internal.seek' call
          var fromIndex_1 = fromIndex_0;
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (null == null) {
              tmp$ret$2 = -1n;
              break $l$block_10;
            } else {
              tmp_0 = null;
            }
            var s = tmp_0;
            var offset = -1n;
            if (targetBytes.v2() === 2) {
              var b0 = targetBytes.w2(0);
              var b1 = targetBytes.w2(1);
              while (offset < this.i3v_1) {
                var data = s.x3v_1;
                var pos = convertToInt(subtract(add(numberToLong(s.y3v_1), fromIndex_0), offset));
                var limit = s.z3v_1;
                while (pos < limit) {
                  var b = data[pos];
                  if (b === b0 || b === b1) {
                    tmp$ret$2 = add(numberToLong(pos - s.y3v_1 | 0), offset);
                    break $l$block_10;
                  }
                  pos = pos + 1 | 0;
                }
                offset = add(offset, fromInt(s.z3v_1 - s.y3v_1 | 0));
                fromIndex_0 = offset;
                s = ensureNotNull(s.c3w_1);
              }
            } else {
              var targetByteArray = targetBytes.i3x();
              while (offset < this.i3v_1) {
                var data_0 = s.x3v_1;
                var pos_0 = convertToInt(subtract(add(numberToLong(s.y3v_1), fromIndex_0), offset));
                var limit_0 = s.z3v_1;
                while (pos_0 < limit_0) {
                  var b_0 = data_0[pos_0];
                  var inductionVariable = 0;
                  var last = targetByteArray.length;
                  while (inductionVariable < last) {
                    var t = targetByteArray[inductionVariable];
                    inductionVariable = inductionVariable + 1 | 0;
                    if (b_0 === t) {
                      tmp$ret$2 = add(numberToLong(pos_0 - s.y3v_1 | 0), offset);
                      break $l$block_10;
                    }
                  }
                  pos_0 = pos_0 + 1 | 0;
                }
                offset = add(offset, fromInt(s.z3v_1 - s.y3v_1 | 0));
                fromIndex_0 = offset;
                s = ensureNotNull(s.c3w_1);
              }
            }
            tmp$ret$2 = -1n;
            break $l$block_10;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s_0 = tmp;
          if (subtract(this.i3v_1, fromIndex_1) < fromIndex_1) {
            var offset_0 = this.i3v_1;
            while (offset_0 > fromIndex_1) {
              s_0 = ensureNotNull(s_0.d3w_1);
              offset_0 = subtract(offset_0, fromInt(s_0.z3v_1 - s_0.y3v_1 | 0));
            }
            var tmp0 = s_0;
            var offset_1 = offset_0;
            var tmp_1;
            if (tmp0 == null) {
              tmp$ret$2 = -1n;
              break $l$block_10;
            } else {
              tmp_1 = tmp0;
            }
            var s_1 = tmp_1;
            var offset_2 = offset_1;
            if (targetBytes.v2() === 2) {
              var b0_0 = targetBytes.w2(0);
              var b1_0 = targetBytes.w2(1);
              while (offset_2 < this.i3v_1) {
                var data_1 = s_1.x3v_1;
                var pos_1 = convertToInt(subtract(add(numberToLong(s_1.y3v_1), fromIndex_0), offset_2));
                var limit_1 = s_1.z3v_1;
                while (pos_1 < limit_1) {
                  var b_1 = data_1[pos_1];
                  if (b_1 === b0_0 || b_1 === b1_0) {
                    tmp$ret$2 = add(numberToLong(pos_1 - s_1.y3v_1 | 0), offset_2);
                    break $l$block_10;
                  }
                  pos_1 = pos_1 + 1 | 0;
                }
                offset_2 = add(offset_2, fromInt(s_1.z3v_1 - s_1.y3v_1 | 0));
                fromIndex_0 = offset_2;
                s_1 = ensureNotNull(s_1.c3w_1);
              }
            } else {
              var targetByteArray_0 = targetBytes.i3x();
              while (offset_2 < this.i3v_1) {
                var data_2 = s_1.x3v_1;
                var pos_2 = convertToInt(subtract(add(numberToLong(s_1.y3v_1), fromIndex_0), offset_2));
                var limit_2 = s_1.z3v_1;
                while (pos_2 < limit_2) {
                  var b_2 = data_2[pos_2];
                  var inductionVariable_0 = 0;
                  var last_0 = targetByteArray_0.length;
                  while (inductionVariable_0 < last_0) {
                    var t_0 = targetByteArray_0[inductionVariable_0];
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    if (b_2 === t_0) {
                      tmp$ret$2 = add(numberToLong(pos_2 - s_1.y3v_1 | 0), offset_2);
                      break $l$block_10;
                    }
                  }
                  pos_2 = pos_2 + 1 | 0;
                }
                offset_2 = add(offset_2, fromInt(s_1.z3v_1 - s_1.y3v_1 | 0));
                fromIndex_0 = offset_2;
                s_1 = ensureNotNull(s_1.c3w_1);
              }
            }
            tmp$ret$2 = -1n;
            break $l$block_10;
          } else {
            var offset_3 = 0n;
            $l$loop: while (true) {
              var tmp0_0 = offset_3;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.z3v_1 - s_0.y3v_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > fromIndex_1)
                break $l$loop;
              s_0 = ensureNotNull(s_0.c3w_1);
              offset_3 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_4 = offset_3;
            var tmp_2;
            if (tmp0_1 == null) {
              tmp$ret$2 = -1n;
              break $l$block_10;
            } else {
              tmp_2 = tmp0_1;
            }
            var s_2 = tmp_2;
            var offset_5 = offset_4;
            if (targetBytes.v2() === 2) {
              var b0_1 = targetBytes.w2(0);
              var b1_1 = targetBytes.w2(1);
              while (offset_5 < this.i3v_1) {
                var data_3 = s_2.x3v_1;
                var pos_3 = convertToInt(subtract(add(numberToLong(s_2.y3v_1), fromIndex_0), offset_5));
                var limit_3 = s_2.z3v_1;
                while (pos_3 < limit_3) {
                  var b_3 = data_3[pos_3];
                  if (b_3 === b0_1 || b_3 === b1_1) {
                    tmp$ret$2 = add(numberToLong(pos_3 - s_2.y3v_1 | 0), offset_5);
                    break $l$block_10;
                  }
                  pos_3 = pos_3 + 1 | 0;
                }
                offset_5 = add(offset_5, fromInt(s_2.z3v_1 - s_2.y3v_1 | 0));
                fromIndex_0 = offset_5;
                s_2 = ensureNotNull(s_2.c3w_1);
              }
            } else {
              var targetByteArray_1 = targetBytes.i3x();
              while (offset_5 < this.i3v_1) {
                var data_4 = s_2.x3v_1;
                var pos_4 = convertToInt(subtract(add(numberToLong(s_2.y3v_1), fromIndex_0), offset_5));
                var limit_4 = s_2.z3v_1;
                while (pos_4 < limit_4) {
                  var b_4 = data_4[pos_4];
                  var inductionVariable_1 = 0;
                  var last_1 = targetByteArray_1.length;
                  while (inductionVariable_1 < last_1) {
                    var t_1 = targetByteArray_1[inductionVariable_1];
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    if (b_4 === t_1) {
                      tmp$ret$2 = add(numberToLong(pos_4 - s_2.y3v_1 | 0), offset_5);
                      break $l$block_10;
                    }
                  }
                  pos_4 = pos_4 + 1 | 0;
                }
                offset_5 = add(offset_5, fromInt(s_2.z3v_1 - s_2.y3v_1 | 0));
                fromIndex_0 = offset_5;
                s_2 = ensureNotNull(s_2.c3w_1);
              }
            }
            tmp$ret$2 = -1n;
            break $l$block_10;
          }
        }
        return tmp$ret$2;
      }
      h3z(offset, bytes) {
        return this.i3z(offset, bytes, 0, bytes.v2());
      }
      i3z(offset, bytes, bytesOffset, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (offset < 0n || bytesOffset < 0 || byteCount < 0 || subtract(this.i3v_1, offset) < fromInt(byteCount) || (bytes.v2() - bytesOffset | 0) < byteCount) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var inductionVariable = 0;
          if (inductionVariable < byteCount)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'kotlin.Long.plus' call
              var tmp$ret$1 = add(offset, fromInt(i));
              if (!(this.v3w(tmp$ret$1) === bytes.w2(bytesOffset + i | 0))) {
                tmp$ret$0 = false;
                break $l$block_0;
              }
            }
             while (inductionVariable < byteCount);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      qc() {
        return Unit_instance;
      }
      q6() {
        return Unit_instance;
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_3: {
          // Inline function 'okio.internal.commonEquals' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_3;
          }
          if (!(other instanceof Buffer())) {
            tmp$ret$0 = false;
            break $l$block_3;
          }
          if (!(this.i3v_1 === other.i3v_1)) {
            tmp$ret$0 = false;
            break $l$block_3;
          }
          if (this.i3v_1 === 0n) {
            tmp$ret$0 = true;
            break $l$block_3;
          }
          var sa = ensureNotNull(this.h3v_1);
          var sb = ensureNotNull(other.h3v_1);
          var posA = sa.y3v_1;
          var posB = sb.y3v_1;
          var pos = 0n;
          var count;
          while (pos < this.i3v_1) {
            var tmp0 = sa.z3v_1 - posA | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = sb.z3v_1 - posB | 0;
            var tmp$ret$1 = Math.min(tmp0, b);
            count = fromInt(tmp$ret$1);
            var inductionVariable = 0n;
            if (inductionVariable < count)
              do {
                var i = inductionVariable;
                inductionVariable = add(inductionVariable, 1n);
                var tmp = sa.x3v_1;
                var tmp1 = posA;
                posA = tmp1 + 1 | 0;
                var tmp_0 = tmp[tmp1];
                var tmp_1 = sb.x3v_1;
                var tmp2 = posB;
                posB = tmp2 + 1 | 0;
                if (!(tmp_0 === tmp_1[tmp2])) {
                  tmp$ret$0 = false;
                  break $l$block_3;
                }
              }
               while (inductionVariable < count);
            if (posA === sa.z3v_1) {
              sa = ensureNotNull(sa.c3w_1);
              posA = sa.y3v_1;
            }
            if (posB === sb.z3v_1) {
              sb = ensureNotNull(sb.c3w_1);
              posB = sb.y3v_1;
            }
            pos = add(pos, count);
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var tmp0_elvis_lhs = this.h3v_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = 0;
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          var result = 1;
          do {
            var pos = s.y3v_1;
            var limit = s.z3v_1;
            while (pos < limit) {
              result = imul(31, result) + s.x3v_1[pos] | 0;
              pos = pos + 1 | 0;
            }
            s = ensureNotNull(s.c3w_1);
          }
           while (!(s === this.h3v_1));
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      toString() {
        return this.j3z().toString();
      }
      j3z() {
        // Inline function 'okio.internal.commonSnapshot' call
        // Inline function 'kotlin.check' call
        if (!(this.i3v_1 <= 2147483647n)) {
          var message = 'size > Int.MAX_VALUE: ' + this.i3v_1.toString();
          throw IllegalStateException().o(toString(message));
        }
        return this.n3y(convertToInt(this.i3v_1));
      }
      n3y(byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonSnapshot' call
          if (byteCount === 0) {
            tmp$ret$0 = Companion_getInstance().d3x_1;
            break $l$block;
          }
          checkOffsetAndCount(this.i3v_1, 0n, fromInt(byteCount));
          var offset = 0;
          var segmentCount = 0;
          var s = this.h3v_1;
          while (offset < byteCount) {
            if (ensureNotNull(s).z3v_1 === s.y3v_1) {
              throw AssertionError().ye('s.limit == s.pos');
            }
            offset = offset + (s.z3v_1 - s.y3v_1 | 0) | 0;
            segmentCount = segmentCount + 1 | 0;
            s = s.c3w_1;
          }
          // Inline function 'kotlin.arrayOfNulls' call
          var size = segmentCount;
          var segments = Array(size);
          var directory = new Int32Array(imul(segmentCount, 2));
          offset = 0;
          segmentCount = 0;
          s = this.h3v_1;
          while (offset < byteCount) {
            segments[segmentCount] = ensureNotNull(s).x3v_1;
            offset = offset + (s.z3v_1 - s.y3v_1 | 0) | 0;
            var tmp = segmentCount;
            // Inline function 'kotlin.comparisons.minOf' call
            var a = offset;
            directory[tmp] = Math.min(a, byteCount);
            directory[segmentCount + segments.length | 0] = s.y3v_1;
            s.a3w_1 = true;
            segmentCount = segmentCount + 1 | 0;
            s = s.c3w_1;
          }
          tmp$ret$0 = new (SegmentedByteString())(isArray(segments) ? segments : THROW_CCE(), directory);
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'Buffer', Buffer);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  UnsafeCursor as UnsafeCursor3vg8iqxvd6n5k,
  Buffer as Buffer3384y49aj0pxr,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
